import request from '@/utils/request'

/**
 * 删除商品
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function deleteProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.deleteProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}